var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"app":""}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-title',{staticClass:"sidebar-title"},[_vm._v(" Sidebar Menu Component ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }